<template>
  <div
    class="common-qr-generator"
    :class="{
      'without-card': !card,
      'button-outline': buttonStyle === 'outline',
    }"
  >
    <div class="qr-code-wrapper" ref="qrCodeWrapper">
      <qrcode-vue
        :value="value || ''"
        :size="size"
        level="M"
        foreground="#111111"
        background="#ffffff"
      />
    </div>
    <button
      class="download-qr-btn"
      type="button"
      :disabled="!value"
      @click="downloadQrCode"
    >
      {{ downloadLabel }}
    </button>
  </div>
</template>

<script>
import QrcodeVue from 'qrcode.vue';

export default {
  name: 'CommonQrGenerator',
  components: {
    QrcodeVue,
  },
  props: {
    value: {
      type: String,
      default: '',
    },
    size: {
      type: Number,
      default: 180,
    },
    downloadLabel: {
      type: String,
      default: 'QR-Code herunterladen',
    },
    fileName: {
      type: String,
      default: 'qr-code',
    },
    card: {
      type: Boolean,
      default: true,
    },
    buttonStyle: {
      type: String,
      default: 'solid',
    },
  },
  methods: {
    downloadQrCode() {
      if (!this.value) return;
      const canvas = this.$refs.qrCodeWrapper?.querySelector('canvas');
      if (!canvas) return;

      const link = document.createElement('a');
      link.href = canvas.toDataURL('image/png');
      link.download = `${this.fileName || 'qr-code'}.png`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
  },
};
</script>

<style scoped>
.common-qr-generator {
  border: 1px solid #dfdfdf;
  border-radius: 10px;
  padding: 14px;
  background: #fff;
  display: flex;
  flex-direction: column;
}

.common-qr-generator.without-card {
  border: none;
  border-radius: 0;
  padding: 0;
}

.common-qr-generator .qr-code-wrapper {
  display: inline-block;
  padding: 10px;
  border-radius: 8px;
  background: #ffffff;
}

.common-qr-generator .download-qr-btn {
  width: 100%;
  min-height: 44px;
  margin: 14px 0 0;
  padding: 0 16px;
  border: 1px solid #151515;
  border-radius: 12px;
  background: #151515;
  color: #fff;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 600;
  transition: all 0.18s ease;
}

.common-qr-generator.button-outline .download-qr-btn {
  background: #fff;
  color: #111111;
}

.common-qr-generator .download-qr-btn:hover:not(:disabled) {
  background: #232323;
  transform: translateY(-1px);
}

.common-qr-generator.button-outline .download-qr-btn:hover:not(:disabled) {
  background: #f5f5f5;
}

.common-qr-generator .download-qr-btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}
</style>
